module.exports = __webpack_public_path__ + "static/img/group28_32.gif";